var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "21px",
    viewBox: "0 0 16 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Key") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1_Signin_01",
    transform: "translate(-797.000000, -471.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(693.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(48.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(52.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Password",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,21 L17,21 L17,19 C17,16.24 14.76,14 12,14 C9.24,14 7,16.24 7,19 L7,21 L6,21 C4.9,21 4,21.9 4,23 L4,33 C4,34.1 4.9,35 6,35 L18,35 C19.1,35 20,34.1 20,33 L20,23 C20,21.9 19.1,21 18,21 Z M12,30 C10.9,30 10,29.1 10,28 C10,26.9 10.9,26 12,26 C13.1,26 14,26.9 14,28 C14,29.1 13.1,30 12,30 Z M15.1,21 L8.9,21 L8.9,19 C8.9,17.29 10.29,15.9 12,15.9 C13.71,15.9 15.1,17.29 15.1,19 L15.1,21 Z",
    id: "Key"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/KeyIcon.b4babb2b58e9571ebc898ed542bd4715.svg";
export { ForwardRef as ReactComponent };